<template>
    <div style="height:32rem;" class="flex items-center">
    <div class="w-1/4 h-full p-6 mt-3 ml-3 shadow-lg bg-gray-50 " >

            <div @click="doScan" class="flex items-center justify-center h-16 text-white bg-yellow-500 rounded-lg shadow-lg cursor-pointer select-none w-44 active:bg-yellow-700">
                <i class="iconfont icon-saoma" style="font-size:20pt;"></i>
                <span class="pl-1 text-lg">识别会员卡</span>
            </div>
<el-divider></el-divider>
            <div v-if="card.card_id!='' && card.card_id!=undefined">
                <p class="leading-none" style="margin-left:-0.5rem;">
                  <i class="iconfont icon-huiyuanqiagoumai" style="font-size:50pt;color:#909090;"></i>
                </p>
                <p class="mb-3">
                  <span class="text-base text-gray-400">卡号</span>
                  <span class="pl-3 text-lg">{{card.card_code}}</span>
                </p>
                 <p class="mb-3">
                  <span class="text-base text-gray-400">余额</span>
                  <span class="pl-3 text-lg">{{card.balance_amount}}</span>
                  <span class="pl-1 text-xs">元</span>
                </p>
                  <p class="mb-3">
                  <span class="text-base text-gray-400">状态</span>
                  <span class="pl-3 text-base">{{card.state_name}}</span>
                </p>
                  <p class="mb-3">
                  <span class="text-base text-gray-400">类型</span>
                  <span class="pl-3 text-base">{{card.card_type_name}}</span>
                </p>
                <p class="mb-3" v-if="card.card_tags.length>0" >
          <span class="text-base text-gray-400">标签</span>
          <span class="text-base">
 <el-tag class="ml-2" type="info" v-for="tag in card.card_tags">{{tag}}</el-tag>
          </span>
        </p>
            </div>
            <div v-else>
                 <el-empty :image-size="200" description="请先识别会员卡"></el-empty>
            </div>

   </div><!--1-->

    <div class="flex-1 h-full pt-6 pl-6 mt-3 ml-3 shadow-lg bg-gray-50" >

         <el-tabs v-model="topupSwitch" @tab-click="handleClick">
             <el-tab-pane label="选择充值方案" name="selRule">

         <div class="mt-3 overflow-y-auto">
                  <div @click="ruleSelFun(rule.key_id)" :class="ruleSel==rule.key_id?'active_field':''" class="float-left w-24 mb-3 mr-4 text-center border rounded cursor-pointer select-none" v-for="rule in ruleList" >
                      <p class="p-3">充</p>
                      <p style="color:#F0AA16">
                        <span class="text-xl">{{rule.income_amount}}</span>
                        <span class="pl-1 text-xs ">元</span>
                      </p>
                      <p class="p-3 text-sm">{{rule.desc_val}}</p>
                  </div>

            </div>
             </el-tab-pane>
            <el-tab-pane label="自定义充值" name="inputVal">

              <div>
            <span class="text-lg text-gray-700 ">本金</span>  &nbsp;
           <el-input-number v-model="amount_cz" max="100000" :precision="2" size="large"    class="mt-2"  />
            &nbsp;
           <el-button @click="showNumPageFun('cz')">小键盘</el-button>
            </div>

            <div class="mt-5">
            <span class="text-lg text-gray-700 ">赠送</span>  &nbsp;
           <el-input-number v-model="amount_zs" max="100000" :precision="2" size="large"    class="mt-2"  />
            &nbsp;
           <el-button @click="showNumPageFun('zs')">小键盘</el-button>
            </div>

            </el-tab-pane>

         </el-tabs>

    </div><!--2-->

    <div class="w-1/4 h-full p-6 mt-3 ml-3 mr-3 shadow-lg bg-gray-50" >
        <p class="text-lg text-gray-700 ">提成员工</p>
           <el-select v-model="awardUser" placeholder="请选择" class="mt-3" >
    <el-option
      v-for="item in awardList"
      :key="item.user_id"
      :value="item.user_id"
      :label="item.user_name"
    >
    </el-option>
  </el-select>

       <p class="mt-6 text-lg text-gray-700 ">收款方式</p>

    <el-radio-group v-model="paymentSel" size="default"  fill="#F0AA16">

    <el-radio :label="payment.payment_id" v-for="payment in paymentList" >{{payment.payment_name}}</el-radio>

  </el-radio-group>

<el-divider></el-divider>

        <div class="mb-3 text-sm base_color">
          {{hjCompute}}
        </div>

        <el-button  class="w-40" style="color: white" color="#626aef" @click="doPublish" >确定充值</el-button>

    </div><!--3-->

  </div>

    <ScanCard @receiveScanReslut="receiveScanReslutFun" @scanCardClose="scanCardCloseFun" :disScanTypeSwitch="true" :series="false" :fromw="fromw" :showView="showScanPage">

    </ScanCard>

   <Keyboard :showView="showNumPage" @numCloseEvent="numCloseFun" @numConfirmEvent="numConfirmFun">

   </Keyboard>

   <el-dialog title="" v-model="dialogResultVisible" top="2vh">

 <el-result icon="success" :title="printResult.tips" subTitle="">

      <template #extra>

              <el-descriptions column="2" >

                 <el-descriptions-item label="单号">{{printResult.bill_id}}&nbsp;</el-descriptions-item>
                 <el-descriptions-item label="时间">{{printResult.oper_time}}</el-descriptions-item>
                 <el-descriptions-item label="卡号">{{printResult.relate_id}}</el-descriptions-item>

                 <el-descriptions-item label="充值">本金{{printResult.amount_income}}元&nbsp;赠送{{printResult.amount_gift}}元</el-descriptions-item>
                <el-descriptions-item label="余额">{{printResult.amount_balance}}元</el-descriptions-item>

                  <el-descriptions-item label="门店">{{printResult.branch_name}}&nbsp;{{printResult.terminal_name}}</el-descriptions-item>

                  <el-descriptions-item label="收银">{{printResult.oper_user_name}}</el-descriptions-item>

                  <el-descriptions-item label="提成">{{printResult.award_user_name}}</el-descriptions-item>
              </el-descriptions>

             <el-button type="info" size="medium" @click="printAgain">补打单据</el-button>
        <el-button type="primary" size="medium" @click="dialogResultVisible=false">返回</el-button>
      </template>
    </el-result>

</el-dialog>

</template>
<script>
import { computed, ref } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import ScanCard from '../components/scanCard/index.vue'
import Keyboard from '../components/keyboard/index.vue'
import { getAwardUser, getPayment, noticePrint } from '@/utils/pos.js'
import { getTopupRule, doTopup } from '@/utils/member.js'
export default {
  setup () {
    const fromw = 4
    const topupSwitch = ref('selRule')
    const amount_cz = ref(0)
    const amount_zs = ref(0)

    const dialogResultVisible = ref(false)
    const printResult = ref({})

    /** 小键盘 **/
    const showNumPage = ref(false)
    const numCloseFun = () => {
      showNumPage.value = false
    }
    const numConfirmFun = (val) => {
      if (tag == 'cz') {
        amount_cz.value = parseFloat(val)
      } else {
        amount_zs.value = parseFloat(val)
      }
    }
    let tag = 'cz'
    const showNumPageFun = (_tag) => {
      showNumPage.value = true
      tag = _tag
    }

    /* 扫码的 */
    const card = ref({})
    const showScanPage = ref(false)
    const receiveScanReslutFun = (cardParam) => {
      card.value = cardParam
    }
    const scanCardCloseFun = () => {
      showScanPage.value = false
    }
    const doScan = () => {
      if (card.value.card_id != '' && card.value.card_id != undefined) {
        ElMessageBox.confirm('本地已有会员卡信息，是否清空?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            card.value = {}
            showScanPage.value = true
          })
      } else {
        showScanPage.value = true
      }
    }

    /* 提成 */
    const awardList = ref([])
    const awardUser = ref('')
    const userMap = {}
    getAwardUser((userList) => {
      awardList.value = userList
      awardUser.value = userList[0].user_id
      for (let i = 0; i < userList.length; i++) {
        userMap[userList[i].user_id] = userList[i]
      }
    })

    /** 收款方式 */
    const paymentList = ref([])
    const paymentSel = ref('')
    const paymentMap = {}
    getPayment((list) => {
      paymentList.value = list
      if (list.length > 0) { paymentSel.value = list[0].payment_id }

      for (let i = 0; i < list.length; i++) {
        paymentMap[list[i].payment_id] = list[i]
      }
    })

    /** 充值方案 */
    const ruleList = ref([])
    const ruleSel = ref('')
    const ruleMap = {}
    getTopupRule((list) => {
      ruleList.value = list
      if (list.length > 0) { ruleSel.value = list[0].key_id }

      for (let i = 0; i < list.length; i++) {
        ruleMap[list[i].key_id] = list[i]
      }
    })

    const ruleSelFun = (ruleID) => {
      ruleSel.value = ruleID
    }

    const hjCompute = computed(() => {
      if (topupSwitch.value == 'selRule' && ruleSel.value != '') {
        const item = ruleMap[ruleSel.value]
        return '本金' + item.income_amount + '元 + 赠送' + item.gift_amount + '元'
      } else {
        return '本金' + amount_cz.value + '元  + 赠送' + amount_zs.value + '元'
      }
    })

    const doPublish = () => {
      if (card.value.card_id == '' || card.value.card_id == undefined) {
        ElMessage({
          showClose: true,
          message: '请先识别会员卡',
          type: 'error'
        })
        return
      }

      let msg = ''
      if (topupSwitch.value == 'selRule') {
        if (ruleSel.value == '') {
          ElMessage({
            showClose: true,
            message: '请先选择充值方案',
            type: 'error'
          })
          return
        }
        msg = '是否确定选择充值方案【' + ruleMap[ruleSel.value].content_val + '】提交充值？'
      } else {
        if (parseFloat(amount_cz.value) == 0) {
          ElMessage({
            showClose: true,
            message: '您选了自定义充值，请输入充值金额',
            type: 'error'
          })
          return
        }
        msg = '是否确定自定义充值【本金' + amount_cz.value + '元' + (parseFloat(amount_zs.value) != 0 ? ',赠送' + amount_zs.value + '元' : '') + '】提交充值？'
      }

      ElMessageBox.confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          doTopup({
            rule_id: topupSwitch.value == 'selRule' ? ruleSel.value : 'N',
            amount_income: amount_cz.value,
            amount_gift: amount_zs.value,
            payment_id: paymentMap[paymentSel.value].payment_id,
            payment_name: paymentMap[paymentSel.value].payment_name,
            card_id: card.value.card_id,
            award_user_id: userMap[awardUser.value].user_id,
            award_user_name: userMap[awardUser.value].user_name
          }, (res) => {
            topupSwitch.value = 'selRule'

            amount_cz.value = 0
            amount_zs.value = 0
            card.value = {}

            printResult.value = res

            dialogResultVisible.value = true
          })
        })
    }
    const printAgain = () => {
      noticePrint(printResult.value.print_id, () => {
        ElMessage({
          showClose: true,
          message: '打印请求成功',
          type: 'success'
        })
      })
    }

    return {
      printAgain,
      showScanPage,
      receiveScanReslutFun,
      scanCardCloseFun,

      amount_cz,
      amount_zs,
      showNumPage,
      numCloseFun,
      numConfirmFun,

      dialogResultVisible,

      awardList,
      awardUser,
      paymentList,
      ruleList,
      paymentSel,
      ruleSel,
      ruleSelFun,
      topupSwitch,
      fromw,
      card,
      doScan,
      hjCompute,
      doPublish,
      showNumPageFun,
      printResult
    }
  },
  components: { ScanCard, Keyboard }
}
</script>
<style scoped>

.active_field{
  border-color:#F0AA16;background-color:#FCF4E9;
}

</style>
